class ProductPageModal extends HTMLElement {
    constructor() {
        super();
        this.closeButton = this.querySelectorAll('.modal-close')
        this.closeButton.forEach(button => button.addEventListener(
            'click',
            this.close.bind(this)
        ))

        this.customFields = this.dataset.customFields ? this.dataset.customFields.split(', ') : null
        this.openButtons = Array.from(document.querySelectorAll('.shipping-button'))
        this.openButtons.forEach(button => button.addEventListener("click", this.open.bind(this, { type: 'shipping-info' })))
        this.submitButtons = document.querySelectorAll(".product-form__submit");
        this.cartDrawer = document.querySelector('cart-drawer');
        this.genericError = "An unexpected error occured. Please try again.";


        this.submitButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                const productType = button.dataset.productType ? button.dataset.productType : null
                const urlParams = new URLSearchParams(window.location.search);
                const isSubscription = urlParams.get("selling_plan");
                const form = button.closest("form");
                const subConsent = document.getElementById('subscription_consent_given')

                const errorTexts = Array.from(document.querySelectorAll('.product-form-error .main-error'))

                errorTexts.forEach(el => {
                    el.classList.add('hide')
                    el.innerText = '* Please complete all fields'
                })

                if (productType === 'demographic_info') {
                    e.preventDefault();
                    e.stopPropagation();
                    this.clearInputs()
                    this.open({ type: 'demographic-info' })

                    const modalAddToCart = this.querySelector('#modal-add-to-cart')

                    if (modalAddToCart) {
                        modalAddToCart.addEventListener("click", (e) => {
                            const formInputs = document.getElementById('demographic-modal-form')
                            const modalForm = new FormData(formInputs)

                            const isValid = this.validateInputs(formInputs, true)

                            if (isValid) {

                                // add inputs to product form
                                for (let [name, value] of modalForm.entries()) {

                                    const hiddenInput = document.createElement('input');
                                    hiddenInput.type = 'hidden';
                                    hiddenInput.name = name;
                                    hiddenInput.value = value;

                                    form.appendChild(hiddenInput);
                                }
                                // add consent date 
                                const consentDateInput = document.createElement('input')
                                consentDateInput.type = 'hidden'
                                consentDateInput.name = 'properties[consent_date]'
                                consentDateInput.value = `${new Date()}`;
                                form.appendChild(consentDateInput)

                                this.addToCart(form, true)
                            }
                        })
                    }

                    return
                }

                if (productType === 'testing_kit') {
                    e.preventDefault();
                    e.stopPropagation();
                    this.clearInputs();
                    this.open({ type: 'testing-kit' })

                    const nextViewButton = this.querySelector('#modal-next-view');
                    const backButton = this.querySelector('#modal-prev-view')
                    const view1 = this.querySelector('#testing-kit')
                    const view2 = this.querySelector('#testing-kit-view-2')

                    if (view1.classList.contains('hidden')) {
                        view1.classList.remove('hidden')
                    }

                    if (!view2.classList.contains('hidden')) {
                        view2.classList.add('hidden')
                    }


                    if (nextViewButton) {
                        nextViewButton.addEventListener("click", () => {

                            // validate form 1 here
                            const view1form = document.getElementById('participant-info-modal-form')
                            const isValid = this.validateInputs(view1form, true)

                            if (isValid) {
                                view1.classList.add('hidden')
                                view2.classList.remove('hidden')
                            }

                        })
                    }


                    const modalAddToCart = this.querySelector('#modal-add-to-cart')

                    if (modalAddToCart) {
                        modalAddToCart.addEventListener("click", (e) => {
                            const shippingFormInputs = document.getElementById('shipping-modal-form')


                            const isValid = this.validateInputs(shippingFormInputs, true, true)

                            if (isValid) {
                                const participantInfo = document.getElementById('participant-info-modal-form')
                                const participantEntries = new FormData(participantInfo)
                                const shippingInfoEntries = new FormData(shippingFormInputs)

                                // add inputs to participant info form
                                for (let [name, value] of participantEntries.entries()) {

                                    const hiddenInput = document.createElement('input');
                                    hiddenInput.type = 'hidden';
                                    hiddenInput.name = name;
                                    hiddenInput.value = value;

                                    form.appendChild(hiddenInput);
                                }
                                for (let [name, value] of shippingInfoEntries.entries()) {

                                    const hiddenInput = document.createElement('input');
                                    hiddenInput.type = 'hidden';
                                    hiddenInput.name = name;
                                    hiddenInput.value = value;

                                    form.appendChild(hiddenInput);
                                }
                                // add consent date 
                                const consentDateInput = document.createElement('input')
                                consentDateInput.type = 'hidden'
                                consentDateInput.name = 'properties[consent_date]'
                                consentDateInput.value = `${new Date()}`;
                                form.appendChild(consentDateInput)

                                this.addToCart(form, true)
                            }
                        })
                    }

                    if (backButton) {
                        backButton.addEventListener("click", () => {

                            view2.classList.add('hidden')
                            view1.classList.remove('hidden')
                        })
                    }

                    return
                }

                // custom fields check
                if (this.customFields) {
                    e.preventDefault();
                    e.stopPropagation
                    const consentDateElement = document.getElementById("consent_date");
                    if (consentDateElement) consentDateElement.value = new Date();

                    const isValid = this.validateInputs(form)

                    if (isSubscription) {
                        if(isValid)this.handleSubscription(subConsent, form)
                    } else {
                        if (isValid) this.addToCart(form)
                    }

                } else {
                    // subscription check 
                    if (isSubscription) {
                        e.preventDefault();
                        e.stopPropagation();
                        this.handleSubscription(subConsent, form)
    
                    }
                }


            });
        });
    }

    open({ type }) {
        if (type === 'shipping-info') {
            this.querySelector("#shipping-info").classList.remove("hidden")
        }

        if (type === 'subscription-confirmation') {
            this.querySelector("#subscription-confirmation").classList.remove("hidden")
        }

        if (type === 'testing-kit') {
            this.querySelector('#testing-kit').classList.remove("hidden")
            this.getQueryParams()
        }

        if (type === 'demographic-info') {
            this.querySelector('#demographic-info').classList.remove("hidden")
            this.getQueryParams()
        }
        this.classList.remove('hidden')
        document.body.classList.add('overflow-hidden');
    }


    close() {
        document.body.classList.remove('overflow-hidden');
        this.classList.add('hidden')

        const modalContent = this.querySelectorAll('.modal-content')
        modalContent.forEach(content => {
            content.classList.add('hidden')
        })
    }

    async addToCart(form, isModal = false) {
        const formData = new FormData(form)
        try {
            const res = await fetch(`${routes.cart_add_url}?sections=cart-drawer,cart-icon-bubble`, {
                method: 'POST',
                headers: {
                    Accept: "application/javascript",
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
            if (!res.ok) {
                const data = await res.json();
                this.renderGeneralError(data.message ?? this.genericError);
                if (isModal) {
                    this.close()
                }
                return;
            }

            const data = await res.json();

            this.updateCart(data)
        } catch (error) {
            console.log(error);
            this.renderGeneralError(this.genericError);
        }
    }

    updateCart(data) {
        this.cartDrawer.renderContents(data);

        if (this.cartDrawer.classList.contains("is-empty")) {
            this.cartDrawer.classList.remove("is-empty")
        }

        this.close()
    }

    getQueryParams() {
        let urlParams = window.location.href.split('?');
        if (urlParams.length > 1) {
          let params = urlParams[1].split('&')
          for (let i = 0; i < params.length; i++) {
            let paramsKeyValue = params[i].split('=');
            if (paramsKeyValue.length > 1) {
              if (paramsKeyValue[0] === 'precision_id') {
                let id_field = document.getElementById('precision_id');
                if (id_field) {
                  id_field.value = decodeURIComponent(paramsKeyValue[1]);
                }
              }
              else if (paramsKeyValue[0] === 'email') {
                let email_field = document.getElementById('email');
                if (email_field) {
                  email_field.value = decodeURIComponent(paramsKeyValue[1]);
                }
              }
            }
          }
        }
      }

    validateInputs(form, isModal = false, isViewTwo = false) {
        this.clearErrors()
        const stringFormat = /^[A-Za-z\s-]+$/;
        const email_format = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/;
        const precision_format1 = /^[A-Za-z]{2}-?\d{5}-?\d{5}$/;
        const precision_format2 = /^NG-?[A-HJ-NP-XZa-hj-np-xz1-9]{9}[A1-9]$/;
        const phoneFormat = /^\+?[0-9]{0,3}[-.\s]?\(?[0-9]{3}\)?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4,6}$/;
        const cityFormat = /^[A-Za-z\s-]+$/;
        const zipCodeFormat = /^\d{5}(?:[-\s]\d{4})?$/
        let noErrors = true
        let allFieldsFilled = true
        const requiredFields = Array.from(form.querySelectorAll('.required'))
        const modalId = isViewTwo ? 'modal-form-error-2' : 'modal-form-error'
        const productFormErrorText = isModal ? document.getElementById(modalId) : document.getElementById('product-form-error')
        productFormErrorText.innerText = '* Please fill out all fields!'

        requiredFields.forEach(formField => {
            if (!formField.value || formField.value.trim() === '') {
                allFieldsFilled = false
            }

            if (formField.type === 'checkbox' && !formField.checked) {
                allFieldsFilled = false
                productFormErrorText.innerText = "* Please Accept our 10X Medial Release"
            }

            if (formField.id === 'first_name') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#first_name_error_message').classList.remove('hide')
                }
            }
            if (formField.id === 'last_name') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#last_name_error_message').classList.remove('hide')
                }
            }

            if (formField.id === 'phone') {
                if (!formField.value.match(phoneFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#phone_error_message').classList.remove('hide')
                }
            }

            if (formField.id === 'email') {
                if (!formField.value.match(email_format)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#email_error_message').classList.remove('hide')
                }
            }

            if (formField.id === 'gender') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#gender_error').classList.remove('hide')
                }
            }

            if (formField.id === 'address') {
                if (formField.value === '') {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#address_error').classList.remove('hide')
                }
            }

            if (formField.id === 'city') {
                if (!formField.value.match(cityFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#city_error').classList.remove('hide')
                }
            }

            if (formField.id === 'zip-code') {
                if (!formField.value.match(zipCodeFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#zip_error').classList.remove('hide')
                }
            }
            if (formField.id === 'state') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#state_error').classList.remove('hide')
                }
            }

            if (formField.id === 'country') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#country_error').classList.remove('hide')
                }
            }

            if (formField.id === 'consent_first_name' || formField.id === 'consent_last_name') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#consent_error').classList.remove('hide')
                }
            }

            if (formField.id === 'precision_id') {
                if (!formField.value.match(precision_format1) && !formField.value.match(precision_format2)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#precision_id_error').classList.remove('hide')
                } else {
                    formField.value = formField.value.replace(/-/g, '');
                  }
            }

            if (formField.id === 'month') {
                //Calculate Age 
                const isMinor = this.determineAge()

                if (formField.dataset.minorStatus === 'disallow' && isMinor) {
                    noErrors = false
                    document.querySelector('#dob_error').classList.remove('hide')
                }

                if (formField.dataset.minorStatus === 'guardian-required' && isMinor) {
                    const guardianEmailInput = this.querySelector('#guardian_email')
                    const guardianEmailError = this.querySelector('#gaurdian_error')
                    if (guardianEmailInput.value) {
                        if (!guardianEmailInput.value.match(email_format)) {
                            noErrors = false
                            guardianEmailError.innerText = '* Please enter a valid email address'
                        } else if (guardianEmailInput.value === document.querySelector('#email').value) {
                            noErrors = false
                            guardianEmailError.innerText = "* Gaurdian Email cannot be the same as Participant's email"
                        }
                    } else {
                        noErrors = false
                        guardianEmailError.innerText = "* Please enter your parent or guardian email address so we can have them provide consent on your behalf."
                        document.querySelector('#gaurdian-email-container').classList.remove('hide')
                    }

                }

            }
        })

        if (!allFieldsFilled) {
            productFormErrorText.classList.remove('hide')
            return false
        }

        if (!noErrors) {
            return false
        }
        return true
    }

    clearErrors() {
        const customInputs = Array.from(document.getElementsByClassName('custom-input'))
        customInputs.forEach(el => el.classList.remove('error_msg'))

        const errorMessages = Array.from(document.getElementsByClassName('product-form-error'))
        errorMessages.forEach(el => el.classList.add('hide'))
    }

    clearInputs() {
        const customInputs = Array.from(document.getElementsByClassName('custom-input'))
        customInputs.forEach(el => {
            if (el.tagName === 'SELECT') {
                el.selectedIndex = 0;
            } else {
                el.value = null;
            }
        })

        const checkbox = this.querySelector("#consent_given")
        if (checkbox) {
            checkbox.checked = false
        }
    }

    renderGeneralError(errorMessage) {
        const productError = document.getElementById("product-form-error");
        if (productError) {
            productError.classList.remove('hide');
            productError.innerText = errorMessage;
        }
    }

    determineAge() {
        const monthValue = this.querySelector('#month').value
        const dayValue = this.querySelector('#day').value
        const yearValue = this.querySelector('#year').value

        const birthdayString = `${monthValue} ${dayValue} ${yearValue}`
        const birthdayDate = new Date(birthdayString)
        const today = new Date()

        let age = today.getFullYear() - birthdayDate.getFullYear()
        const monthDiff = today.getMonth() - birthdayDate.getMonth()
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdayDate.getDate())) {
            age--;
        }
        return age < 18

    }

    handleSubscription (subConsent, form) {
        this.open({ type: 'subscription-confirmation' })
        const addToCartBtn = document.getElementById('subcription-add-to-cart')
        
        subConsent.addEventListener('change', function () {
            addToCartBtn.disabled = !this.checked;
        });

        addToCartBtn.addEventListener("click", async () => {
            const formData = new FormData(form)
            try {
                const res = await fetch(`${routes.cart_add_url}?sections=cart-drawer,cart-icon-bubble`, {
                    method: 'POST',
                    headers: {
                        Accept: "application/javascript",
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: formData
                })

                if (!res.ok) {
                    const data = await res.json();
                    this.close();
                    this.renderGeneralError(data.message ?? this.genericError);
                }

                const data = await res.json();

                this.updateCart(data)
                subConsent.checked = false
            } catch (error) {
                console.log(error);
                this.renderGeneralError(this.genericError);
                this.close();
            }
        })
    }
}

customElements.define('product-page-modal', ProductPageModal);
